import {ACTIVE_REGION} from './regionType';
const initialState = {
    region: 'active'
}
export const activeReducer = (state=initialState,action:any) => {
    switch(action.type) {
        case ACTIVE_REGION:
            return {
                ...state,
                region: action.activatedRegion
            }
        default: return state
    }
}